<template>
  <div class="videoWrapper">
    <iframe
      v-if="iframeSrc"
      class="iframe"
      title="Report Section"
      :src="iframeSrc"
      frameborder="0"
      allowFullScreen="true"
      ref="reportIframe"
    />
    <div v-else>
      Loading Grafana Dashboard...
    </div>
    <button
      v-if="iframeSrc"
      class="fullscreen-btn"
      @click="goFullScreen"
      title="Full Screen"
    >
      ⛶
    </button>
  </div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import axios from 'axios'

export default {
  setup() {
    const iframeSrc = ref('')
    const reportIframe = ref(null)
    const DASHBOARD_UID = 'eeidezzaphwjkf'

    const goFullScreen = () => {
      const iframe = reportIframe.value
      if (iframe) {
        if (iframe.requestFullscreen) {
          iframe.requestFullscreen()
        } else if (iframe.mozRequestFullScreen) {
          iframe.mozRequestFullScreen()
        } else if (iframe.webkitRequestFullscreen) {
          iframe.webkitRequestFullscreen()
        } else if (iframe.msRequestFullscreen) {
          iframe.msRequestFullscreen()
        }
      }
    }

    onMounted(async () => {
      try {
        const backendUrl = useAppConfig().AxiosUrl
        const response = await axios.get(`${backendUrl}api_mes/grafana/${DASHBOARD_UID}`)

        if (response.data.success) {
          // Resolve base ke URL absolut terhadap origin halaman, agar aman baik saat
          // AxiosUrl absolut, relatif, root, maupun berprefix path (mis. /api).
          const backendOrigin = new URL(backendUrl || '/', window.location.origin).origin
          iframeSrc.value = new URL(response.data.iframeSrc.replace(/^\//, ''), `${backendOrigin}/`).href
        } else {
          console.error('Failed to get Grafana iframe URL:', response.data.message)
        }
      } catch (error) {
        console.error('Error fetching Grafana iframe URL:', error)
      }

      const params = new URLSearchParams()
      params.append('emp_id', localStorage.getItem('id'))
      params.append('nik', localStorage.getItem('nik'))
      params.append('report', 'Reject & Recycle - Preview')
      await axios.post(`${useAppConfig().AxiosUrl}api_mes/user-mes/logreport`, params)
    })

    return {
      iframeSrc,
      reportIframe,
      goFullScreen,
    }
  },
}
</script>

<style>
.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
}

.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(156, 39, 176, 0.15);
}

.fullscreen-btn {
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 10;
  background: var(--primary, #1976d2);
  color: #fff;
  border: none;
  border-radius: 50%;
  padding: 12px 16px;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(156,39,176,0.15);
  transition: background 0.2s, color 0.2s;
}

.fullscreen-btn:hover {
  background: #42a5f5;
  color: #fff;
}
</style>
